import sgMail from '@sendgrid/mail';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

let sendgridInitialized = false;

function initializeSendGrid() {
  if (!sendgridInitialized) {
    const apiKey = process.env.SENDGRID_API_KEY;
    if (!apiKey) {
      throw new Error('SENDGRID_API_KEY environment variable is required');
    }
    sgMail.setApiKey(apiKey);
    sendgridInitialized = true;
  }
}

export async function sendEmail(to: string, subject: string, text: string, html: string, transactionId?: string, tenantId?: string) {
  initializeSendGrid();
  
  const msg = {
    to,
    from: 'admin@growezy.ai',
    subject,
    text,
    html,
  };

  try {
    await sgMail.send(msg);
    
    // Log success
    await addDoc(collection(db, 'email_logs'), {
      transactionId: transactionId || 'N/A',
      tenantId: tenantId || 'N/A',
      recipient: to,
      subject,
      status: 'sent',
      timestamp: serverTimestamp(),
    });

    return { success: true };
  } catch (error) {
    console.error('SendGrid error:', error);
    
    // Log failure
    try {
        await addDoc(collection(db, 'email_logs'), {
          transactionId: transactionId || 'N/A',
          tenantId: tenantId || 'N/A',
          recipient: to,
          subject,
          status: 'failed',
          error: error instanceof Error ? error.message : 'Unknown error',
          timestamp: serverTimestamp(),
        });
    } catch (logError) {
        console.error('Failed to log email error:', logError);
    }
    throw error;
  }
}
